import React, { Children } from 'react';
import { ClockIcon, StarIcon, CoffeeIcon, UsersIcon, MicIcon, UtensilsIcon, LayoutGridIcon, HandHeartIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const scheduleData = [{
  time: '9:30 AM',
  title: 'Registration & Fellowship',
  subtitle: 'Check in and connect with fellow men of faith',
  type: 'normal',
  icon: CoffeeIcon
}, {
  time: '10:00 AM',
  title: 'Welcome & Prayer',
  subtitle: 'Opening the day in unity',
  type: 'normal',
  icon: HandHeartIcon
}, {
  time: '10:20 AM',
  title: 'Elderly Men Panel Discussion',
  subtitle: 'Wisdom from seasoned men of God',
  type: 'normal',
  icon: UsersIcon
}, {
  time: '11:20 AM',
  title: 'Break/Transition',
  subtitle: 'Stretch and refresh',
  type: 'break',
  icon: CoffeeIcon
}, {
  time: '11:30 AM',
  title: 'Breakout Sessions',
  subtitle: '3 tracks: Financial, Missionary, Marriage',
  type: 'normal',
  icon: LayoutGridIcon
}, {
  time: '12:15 PM',
  title: 'Transition/Networking',
  subtitle: 'Connect with other attendees',
  type: 'break',
  icon: UsersIcon
}, {
  time: '12:30 PM',
  title: 'Keynote: "Walking in Your Calling"',
  subtitle: 'The main event — be inspired and challenged',
  type: 'keynote',
  icon: MicIcon
}, {
  time: '1:30 PM',
  title: 'Closing Remarks & Blessing',
  subtitle: 'Sending forth',
  type: 'normal',
  icon: HandHeartIcon
}, {
  time: '1:40 PM',
  title: 'Meal and Fellowship Luncheon',
  subtitle: 'Break bread together in fellowship',
  type: 'normal',
  icon: UtensilsIcon
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 24
    }
  }
};
export function SchedulePage() {
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-145">
      <div className="bg-gradient-to-br from-[#7B2D8E] to-[#5a2168] pt-12 pb-8 px-6 rounded-b-[2rem] shadow-lg relative overflow-hidden" data-id="element-146">
        <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-white opacity-5 rounded-full blur-2xl" data-id="element-147" />
        <h1 className="text-3xl font-black text-white mb-2 relative z-10" data-id="element-148">
          Event Schedule
        </h1>
        <p className="text-[#D4A017] font-bold flex items-center relative z-10" data-id="element-149">
          <ClockIcon className="w-5 h-5 mr-2" data-id="element-150" />
          Saturday, April 25, 2026
        </p>
      </div>

      <div className="px-6 py-8" data-id="element-151">
        <motion.div variants={containerVariants} initial="hidden" animate="show" className="relative border-l-2 border-gray-200 ml-4 space-y-8" data-id="element-152">
          {scheduleData.map((item, index) => {
          const isKeynote = item.type === 'keynote';
          const isBreak = item.type === 'break';
          const Icon = item.icon;
          return <motion.div key={index} variants={itemVariants} className="relative pl-8" data-id="element-153">
                {/* Timeline Dot */}
                <div className={`absolute -left-[11px] top-2 w-5 h-5 rounded-full border-[3px] bg-white flex items-center justify-center ${isKeynote ? 'border-[#D4A017] w-7 h-7 -left-[15px] -top-0' : isBreak ? 'border-gray-300' : 'border-[#7B2D8E]'}`} data-id="element-154">
                  {isKeynote && <>
                      <div className="absolute inset-0 bg-[#D4A017] rounded-full animate-ping opacity-20" data-id="element-155" />
                      <div className="w-2.5 h-2.5 bg-[#D4A017] rounded-full" data-id="element-156" />
                    </>}
                  {!isKeynote && !isBreak && <div className="w-1.5 h-1.5 bg-[#7B2D8E] rounded-full" data-id="element-157" />}
                </div>

                {/* Content Card */}
                <div className={`p-5 rounded-2xl shadow-sm border relative overflow-hidden ${isKeynote ? 'bg-gradient-to-br from-[#7B2D8E] to-[#4a1459] text-white border-transparent shadow-xl shadow-purple-900/20 transform scale-[1.03] z-10' : isBreak ? 'bg-gray-100/80 border-gray-200 text-gray-500' : 'bg-white border-gray-100 text-[#374151] hover:shadow-md transition-shadow'}`} data-id="element-158">
                  {/* Keynote Shimmer & Badge */}
                  {isKeynote && <>
                      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full animate-[shimmer_2s_infinite]" data-id="element-159" />
                      <div className="absolute top-0 right-0 bg-[#D4A017] text-[#7B2D8E] text-[10px] font-black px-3 py-1 rounded-bl-xl tracking-widest uppercase" data-id="element-160">
                        Keynote
                      </div>
                    </>}

                  <div className="flex items-start gap-4" data-id="element-161">
                    <div className={`p-3 rounded-xl flex-shrink-0 ${isKeynote ? 'bg-white/10 text-[#D4A017]' : isBreak ? 'bg-gray-200 text-gray-400' : 'bg-purple-50 text-[#7B2D8E]'}`} data-id="element-162">
                      <Icon className="w-6 h-6" data-id="element-163" />
                    </div>

                    <div className="flex-1 pt-1" data-id="element-164">
                      <div className={`text-sm font-black mb-1 ${isKeynote ? 'text-[#D4A017]' : isBreak ? 'text-gray-400' : 'text-[#7B2D8E]'}`} data-id="element-165">
                        {item.time}
                      </div>
                      <h3 className={`font-bold text-lg leading-tight mb-1.5 ${isKeynote ? 'text-white text-xl' : 'text-gray-900'}`} data-id="element-166">
                        {item.title}
                      </h3>
                      <p className={`text-sm font-medium leading-snug ${isKeynote ? 'text-purple-200' : 'text-gray-500'}`} data-id="element-167">
                        {item.subtitle}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </div>;
}